/* PDP redesign · Sticky add bar — visibility + qty stepper.
   Visible whenever the hero ATC is OFF-screen (above or below viewport). */

(function () {
  function initVisibility() {
    const bar = document.querySelector('.pdp-sticky');
    if (!bar) return;
    const sentinel = document.querySelector('.pdp-hero__atc-wrap');
    if (!sentinel) {
      bar.classList.add('is-visible');
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) bar.classList.remove('is-visible');
        else bar.classList.add('is-visible');
      });
    }, { threshold: 0 });
    io.observe(sentinel);
  }

  function initQtyPicker(root) {
    const input = root.querySelector('.pdp-sticky__qty-input');
    const buttons = root.querySelectorAll('[data-qty-step]');
    if (!input || !buttons.length) return;

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.qtyStep, 10) || 0;
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function init() {
    initVisibility();
    document.querySelectorAll('.pdp-sticky [data-qty-picker]').forEach(initQtyPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
